import type { AuditLogEvent } from '../../../domain/audit-log-event'

import { AuditLogAction } from '../../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../../domain/audit-log-resource-type.enum'

import { CheckRunRerunSummaryColumn } from './check-run-rerun-summary-column'
import { GroupUpdateSummaryColumn } from './group-update-summary-column'

interface Props {
  auditLog: AuditLogEvent
}

export const SummaryColumn = (props: Props): JSX.Element => {
  let SummaryColumn

  if (
    props.auditLog.resource?.type === AuditLogResourceType.CheckRun &&
    props.auditLog.action === AuditLogAction.Rerun
  ) {
    SummaryColumn = CheckRunRerunSummaryColumn
  } else if (
    props.auditLog.resource?.type === AuditLogResourceType.Group &&
    props.auditLog.action === AuditLogAction.Update
  ) {
    SummaryColumn = GroupUpdateSummaryColumn
  } else {
    SummaryColumn = EmptySummaryColumn
  }

  return SummaryColumn && <SummaryColumn auditLog={props.auditLog} />
}

const EmptySummaryColumn = (_props: Props): JSX.Element | null => {
  return null
}
